import { Component } from '@angular/core';
import { LoaderServiceService } from '../Services/loader-service.service';

@Component({
  selector: 'app-loader',
  standalone: false,
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css'
})
export class LoaderComponent {
 constructor(public loaderService: LoaderServiceService) {}
}
